import type { CSSProperties, ComplexStyleRule } from '@vanilla-extract/css'
import { type PartialRecord } from './utilTypes'

export type Level = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export type ResponsiveLevel = '_' | Level

export const breakpoints: Record<Level, number> = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
}

export const mq = Object.fromEntries(
  Object.entries(breakpoints).map(([name, width]) => {
    return [name, `@media screen and (min-width: ${width}px)`]
  }),
)

export const getMediaQueryBreakpoint = (level: Level) => {
  const breakpointWidth = breakpoints[level]
  if (!breakpointWidth) throw new Error(`Unknown breakpoint ${level}`)
  return breakpointWidth
}

export const animationAllowed = '(prefers-reduced-motion: no-preference)'

export const minWidth = Object.fromEntries(
  Object.entries(breakpoints).map(([name, width]) => {
    return [name, `screen and (min-width: ${width}px)`]
  }),
) as Record<Level, string>

// Media queries for use in sprinkles
export const mediaQueries = Object.fromEntries(
  Object.entries(breakpoints).map(([name, width]) => {
    return [name, { '@media': `screen and (min-width: ${width}px)` }]
  }),
)

export const hoverStyles = (styles: ComplexStyleRule) => {
  return {
    '@media (hover: hover)': {
      '&:hover': styles,
    },
  }
}

// Copied from vanilla-extract since it does not export it
type CSSPropertiesWithVars = CSSProperties & {
  vars?: {
    [key: string]: string
  }
}

export const responsiveStyles = (breakpointStyles: PartialRecord<Level, CSSPropertiesWithVars>) => {
  return {
    '@media': Object.fromEntries(
      Object.entries(breakpointStyles).map(([key, styles]) => [minWidth[key as Level], styles]),
    ),
  } as const
}
